import api from './api'

// eslint-disable-next-line no-unused-vars
export default (aioAPI, chalice) => ({
  addTags () {
    for (let tag of defaultTags) {
      api.tag.create(tag)
    }
  },
})

const defaultTags = [
  // Categories
  'client',
  'facilities',
  'hosting',
  'legal',
  'llama',
  'miscellaneous',
  'office',
  'travel',
  'web services',

  // Nouns
  'accommodation',
  'advertising',
  'batteries',
  'cake',
  'equipment',
  'fuel',
  'hotel',
  'ink',
  'inoculation',
  'insurance',
  'laundry',
  'lunch',
  'paper',
  'parking',
  'phone contract',
  'postage',
  'refreshments',
  'software',
  'stationery',
  'training',
  'transport',
  'utilities',
  'warranty',
  'workwear',

  // Adjectives
  'consumable',
  'durable',
  'essential',
  'large',
  'luxury',
  'medium',
  'nice to have',
  'service',
  'small',
  'useful',
]
